import { useEffect, useState } from 'react'
import { gql, useSubscription } from '@apollo/client'

const SUBSCRIPTION_HEARTBEAT = gql`
  subscription SubscriptionHeartbeat {
    subscriptionHeartbeat {
      serverTime
    }
  }
`

interface SubscriptionHeartbeatData {
  subscriptionHeartbeat: {
    serverTime: string
  }
}

const useSubscriptionHeartbeat = () => {
  const [lastHeartbeatAt, setLastHeartbeatAt] = useState(() => Date.now())
  const { data, error } = useSubscription<SubscriptionHeartbeatData>(SUBSCRIPTION_HEARTBEAT)

  useEffect(() => {
    if (data?.subscriptionHeartbeat?.serverTime) {
      setLastHeartbeatAt(Date.now())
    }
  }, [data])

  useEffect(() => {
    if (error) {
      console.error('Subscription heartbeat failed:', error.message)
    }
  }, [error])

  return { lastHeartbeatAt, error }
}

export default useSubscriptionHeartbeat
